<template>
    <section class="dynamic">
        <div v-for="v in activities" :key="v.id" class="dynamic-list">
            <div class="dynamic-header">
                <img :src="avatar" class="dancer-avatar" alt="">
                <div class="dynamic-owner">
                    <div class="dancer-name">{{dancer}}</div>
                    <div class="dynamic-time">{{$time(v.addtime)}}</div>
                </div>
            </div>
            <div v-if="v.type === 1" :style="`height: ${100 / (v.width / v.height)}vw;background-image: url(${v.thumb})`" class="thumb"></div>
            <video v-if="v.type === 2" :src="v.src" :poster="v.thumb" class="video" controls="controls" webkit-playsinline="true" playsinline="true" x-webkit-airplay="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-ignore-metadata="true"></video>
            <swiper v-if="v.type === 3" :options="{
                slidesPerView: 'auto',
                freeModeSticky : true,
                pagination: {
                    el: `.page-${v.id}`
                },
            }">
                <swiper-slide v-for="(vv, kk) in v.media" :key="`${v.id}-${kk}`" class="swiper-slide">
                    <video v-if="vv.is_video" :src="vv.src" :poster="v.thumb" class="video" controls="controls" webkit-playsinline="true" playsinline="true" x-webkit-airplay="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-ignore-metadata="true"></video>
                    <div v-if="!vv.is_video" :style="`height: ${100 / (vv.width / vv.height)}vw;background-image: url(${vv.thumb})`" class="thumb"></div>
                </swiper-slide>
            </swiper>
            <div class="dynamic-tool">
                <div v-if="v.type === 3" :class="`dynamic-pagination page-${v.id}`" slot="pagination"></div>

                <div class="df">
                    <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app"><i class="icon-like"></i></a>
                    <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app"><i class="icon-comment"></i></a>
                    <router-link :to="`/dancers/activities/${v.id}`"><i class="icon-share"></i></router-link>
                </div>
                <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app"><i class="icon-collect"></i></a>
            </div>
            <router-link :to="`/dancers/activities/${v.id}`" class="dynamic-footer">
                <div class="dynamic-like">{{v.likes}} 次赞 · {{v.comments}} 条评论</div>
                <div class="dynamic-title">{{v.title}}</div>
            </router-link>
        </div>
        <div v-show="isLoading" class="loading-box"><div class="loading"></div></div>
        <div v-show="!isLoading && !activities.length" class="empty">暂时没有动态(～￣▽￣)～</div>
        <a v-if="!isLoading && activities.length" class="empty download" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app">查看全部动态，请下载 Vhiphop 客户端 &gt;&gt;</a>
    </section>
</template>

<script>
    export default {
        props: {
            dancer: String,
            avatar: String,
        },
        data: () => ({
            activities: [],
            isLoading: true,
        }),
        computed: {
            id() {
                return +this.$route.params.id || 0;
            },
            sort() {
                return +this.$route.query.sort || 0;
            }
        },
        async beforeMount() {
            this.activities = await this.api.get(`dancers/${this.id}/activities`).catch(this.err);
            this.isLoading = false;
            this.$share(this.dancer, this.avatar);
        },
    }
</script>

<style scoped>
    @import '../../../static/css/dancer/activity.css';
</style>


// WEBPACK FOOTER //
// src/components/dancer/Activity.vue